const styles = theme => ({
  root: {
    height: '100%',
  },
  drawerHeader:{
    display:'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 25,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    '& h2':{
      fontWeight: 400,
      fontSize: '1.2rem',
      textTransform: 'uppercase',
    },
    '& button': {
      color: 'white',
      padding:0,
      minWidth: '36px',
    }

  },
  drawerContent:{
    width: 300,
    '& a': {
      padding: '20px 35px',
    },
    '& h3':{
      color: theme.palette.primary.main,
      width: '300px'
    },
  },
  navItems: {
    padding: '20px 35px',
  },
  flex: {
    flex: 1
  },
})

export default styles
